'use strict';

const { alertMessage } = require('../common/common');

const handleNewsletterSuccess = ($form, data) => {
    if (data && data.success) {
        $form.spinner().stop();
        alertMessage(data.message, 'cc-alert--success');
    } else {
        $form.spinner().stop();
        alertMessage(data.message, 'cc-alert--danger');
    }
};

const handleNewsletterError = ($form, err) => {
    $form.spinner().stop();
    alertMessage(err, 'cc-alert--danger');
};

module.exports = {
    submitUnsubscribe: function () {
        $('form.newsletter-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    handleNewsletterSuccess($form, data);
                },
                error: function (err) {
                    handleNewsletterError($form, err);
                }
            });
            return false;
        });
    }
};